var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.105.957a1 1 0 0 1 1.79 0l1.934 3.89 4.31.623a1 1 0 0 1 .552 1.708l-3.113 3.014.736 4.264a1 1 0 0 1-1.448 1.056L8 13.494l-3.866 2.018a1 1 0 0 1-1.448-1.056l.737-4.264L.309 7.178A1 1 0 0 1 .862 5.47l4.309-.622z"
  })));
};
export { SvgStar as ReactComponent };